import styled from 'styled-components'
import { colors } from '../Global/variaveis'

export const StyleFooter = styled.div`
  color: ${colors.gray};
  text-align: center;
  padding: 50px;
`
